
if (window.innerWidth > 768) {
  let observerAttached = false;

  document
    .querySelector(".wizzy-search-input")
    .addEventListener("click", function () {
      const searchPopdown = document.querySelector(
        ".header__desktop__button header-search-popdown"
      );

      if (!searchPopdown) return;

      const toggleAutocompleteVisibility = () => {
        const autocompleteWrapper = document.querySelector(
          ".wizzy-autocomplete-wrapper.onLeft"
        );

        if (!autocompleteWrapper) return;

        if (!searchPopdown.classList.contains("is-open")) {
          autocompleteWrapper.style.setProperty("display", "none");
        }
      };

      const waitForAutocomplete = () => {
        const autocompleteWrapper = document.querySelector(
          ".wizzy-autocomplete-wrapper.onLeft"
        );

        if (!autocompleteWrapper) {
          setTimeout(waitForAutocomplete, 200);
          return;
        }

        toggleAutocompleteVisibility();

        if (!observerAttached) {
          const observer = new MutationObserver(() => {
            toggleAutocompleteVisibility();
          });

          observer.observe(searchPopdown, {
            attributes: true,
            attributeFilter: ["class"],
          });

          observerAttached = true;
        }
      };

      waitForAutocomplete();
    });
}


if (window.innerWidth < 768) {
  let observerAttached = false;

  document
    .querySelector(".wizzy-search-input")
    .addEventListener("click", function () {
      const searchPopdown = document.querySelector(
        ".header__mobile__button header-search-popdown"
      );

      if (!searchPopdown) return;

      const toggleAutocompleteVisibility = () => {
        const autocompleteWrapper = document.querySelector(
          ".wizzy-autocomplete-wrapper.onLeft"
        );

        if (!autocompleteWrapper) return;

        if (!searchPopdown.classList.contains("is-open")) {
          autocompleteWrapper.style.setProperty("display", "none");
        }
      };

      const waitForAutocomplete = () => {
        const autocompleteWrapper = document.querySelector(
          ".wizzy-autocomplete-wrapper.onLeft"
        );

        if (!autocompleteWrapper) {
          setTimeout(waitForAutocomplete, 200);
          return;
        }

        toggleAutocompleteVisibility();

        if (!observerAttached) {
          const observer = new MutationObserver(() => {
            toggleAutocompleteVisibility();
          });

          observer.observe(searchPopdown, {
            attributes: true,
            attributeFilter: ["class"],
          });

          observerAttached = true;
        }
      };

      waitForAutocomplete();
    });
}

// =============================================================================
// Wizzy-only: snippets/wizzy.search.product.liquid + wizzy.autoComplete.products.liquid
// (Remove this block to drop injected-search ATC/qty behaviour; collection uses assets/custom.js)
// =============================================================================
// Must match assets/custom.js checkCartLimits (max 5 units per variant)
var WIZZY_MAX_UNITS_PER_VARIANT = 5;
var WIZZY_MAX_CART_ITEMS = 25;

// checkCartLimits() only renders into .product-error-wrapper when itemCartKey is passed; Wizzy ATC uses qty-only calls.
function showWizzyProductError(variantId, messageHtml) {
  if (!variantId || !messageHtml) return;
  const id = String(variantId);
  const sel = `.wizzy-result-product .product-error-wrapper[data-variant-id="${id}"], .topproduct-item .product-error-wrapper[data-variant-id="${id}"]`;
  document.querySelectorAll(sel).forEach(function (wrap) {
    const msg = wrap.querySelector(".product-error-message");
    if (!msg) return;
    msg.innerHTML = messageHtml;
    wrap.style.display = "flex";
    wrap.style.justifyContent = "center";
    wrap.style.alignItems = "center";
    window.setTimeout(function () {
      wrap.style.display = "none";
      msg.innerHTML = "";
    }, 2000);
  });
}

function getWizzyProductCard(element) {
  return element?.closest(".wizzy-result-product, .topproduct-item");
}

function parseLineItemFromCartAddResponse(response) {
  if (!response) return null;
  if (Array.isArray(response.items) && response.items.length) return response.items[0];
  if (response.key != null || response.variant_id != null) return response;
  return null;
}

function getQuantityFromCartAddResponse(response) {
  const line = parseLineItemFromCartAddResponse(response);
  if (line && typeof line.quantity === "number") return line.quantity;
  if (response && typeof response.quantity === "number") return response.quantity;
  return null;
}

function findCartItemByVariantId(cart, variantId) {
  if (!cart?.items || variantId == null) return null;
  const vid = String(variantId);
  return cart.items.find(
    (item) => String(item.variant_id) === vid || String(item.id) === vid
  );
}

function updateWizzyQuantityWrappersForVariant(variantId, line) {
  if (!line) return;
  const sel = `.wizzy-result-product .quantity-wrapper[data-variant-id="${variantId}"], .topproduct-item .quantity-wrapper[data-variant-id="${variantId}"]`;
  const wrappers = document.querySelectorAll(sel);
  const rawQty = line.quantity;
  const parsed =
    typeof rawQty === "number" ? rawQty : parseInt(String(rawQty), 10);
  const qty = Number.isFinite(parsed)
    ? Math.min(Math.max(parsed, 0), WIZZY_MAX_UNITS_PER_VARIANT)
    : null;
  const key = line.key;

  wrappers.forEach((qtyWrapper) => {
    qtyWrapper.classList.add("active-qty");
    const cartQuantityElem = qtyWrapper.querySelector(".cart-quantity");
    const productQuantityInc = qtyWrapper.querySelector(".increase-cart-qty");
    const productQuantityDec = qtyWrapper.querySelector(".decrease-cart-qty");

    if (cartQuantityElem != null && qty !== null) {
      cartQuantityElem.textContent = String(qty);
    }
    if (key) {
      qtyWrapper.setAttribute("data-key", key);
      if (productQuantityInc) productQuantityInc.setAttribute("data-key", key);
      if (productQuantityDec) productQuantityDec.setAttribute("data-key", key);
    }
  });
}

let wizzyInteractionsAttached = false;
function attachWizzyProductInteractions() {
  if (wizzyInteractionsAttached) return;
  wizzyInteractionsAttached = true;

  document.addEventListener("click", function (event) {
    console.log("click on atc from search page")
    const card = getWizzyProductCard(event.target);
    if (!card) return;

    if (event.target.closest(".add-to-cart-btn")) {
      const button = event.target.closest(".add-to-cart-btn");
      if (card.classList.contains("topproduct-item")) {
        event.preventDefault();
        event.stopPropagation();
      }
      const qty = button.getAttribute("data-quantity") || "1";
      const variantId = button.getAttribute("data-variant-id");
      const addQty = parseInt(qty, 10) || 1;
      checkCartLimits(qty).then((cart) => {
        if (!cart) return;

        if (cart.item_count >= WIZZY_MAX_CART_ITEMS) {
          showWizzyProductError(
            variantId,
            "Cart limit reached! You can add up to 25 items only."
          );
          return;
        }
        if (addQty > WIZZY_MAX_UNITS_PER_VARIANT) {
          showWizzyProductError(
            variantId,
            "Limit reached! You can add up to 5 units only."
          );
          return;
        }
        const existing = findCartItemByVariantId(cart, variantId);
        if (
          existing &&
          existing.quantity + addQty > WIZZY_MAX_UNITS_PER_VARIANT
        ) {
          showWizzyProductError(
            variantId,
            "Limit reached! You can add up to 5 units only."
          );
          return;
        }

        const formData = new FormData();
        const productId = button.getAttribute("data-product-id") || variantId;
        formData.append("id", variantId);
        formData.append("form_type", "product");
        formData.append("utf8", "✓");
        formData.append("quantity", qty);
        if (productId) formData.append("product-id", productId);
        formData.append("section-id", "template--17632417120300__main");
        document.dispatchEvent(
          new CustomEvent("theme:cart:add", {
            detail: { button, formData },
            bubbles: false,
          })
        );
        console.log({
  variantId,
  qty,
  productId,
  button
});
      });
      return;
    }

    if (event.target.closest(".decrease-cart-qty")) {
      const decreaseBtn = event.target.closest(".decrease-cart-qty");
      const wrapper = decreaseBtn.closest(".quantity-wrapper");
      if (!wrapper) return;
      if (card.classList.contains("topproduct-item")) {
        event.preventDefault();
        event.stopPropagation();
      }
      const variantId = wrapper.getAttribute("data-variant-id");
      const increaseBtn = wrapper.querySelector(".increase-cart-qty");
      increaseBtn?.removeAttribute("disabled");
      const cartMinusBtn = document.querySelector(
        `.cart__quantity-minus[data-productitem-id="${variantId}"]`
      );
      if (cartMinusBtn) {
        cartMinusBtn.click();
      } else {
        wrapper.classList.remove("active-qty");
        const parentElement =
          getWizzyProductCard(decreaseBtn) || wrapper?.parentElement?.parentElement;
        if (parentElement) {
          parentElement.querySelector(".add-to-cart-btn")?.classList.remove("hide-atc_btn");
        }
      }
      setTimeout(() => syncCartUI(), 3000);
      return;
    }

    if (event.target.closest(".increase-cart-qty")) {
      const increaseBtn = event.target.closest(".increase-cart-qty");
      const wrapper = increaseBtn.closest(".quantity-wrapper");
      if (!wrapper) return;
      if (card.classList.contains("topproduct-item")) {
        event.preventDefault();
        event.stopPropagation();
      }
      const variantId = wrapper.getAttribute("data-variant-id");
      const cartPlusBtn = document.querySelector(
        `.cart__quantity-plus[data-productitem-id="${variantId}"]`
      );
      if (!cartPlusBtn) return;
      checkCartLimits(null).then((cart) => {
        if (!cart || !cart.items) return;
        const item = findCartItemByVariantId(cart, variantId);
        if (item && item.quantity >= WIZZY_MAX_UNITS_PER_VARIANT) {
          showWizzyProductError(
            variantId,
            "Limit reached! You can add up to 5 units only."
          );
          return;
        }
        if (cart.item_count >= WIZZY_MAX_CART_ITEMS) {
          showWizzyProductError(
            variantId,
            "Cart limit reached! You can add up to 25 items only."
          );
          return;
        }
        cartPlusBtn.click();
      });
      setTimeout(() => syncCartUI(), 500);
      return;
    }
  });

  document.addEventListener("theme:product:add", function (event) {
    const button = event.detail.button;
    if (!button || !getWizzyProductCard(button)) return;

    const response = event.detail.response;
    const buttonId = button.getAttribute("data-variant-id");
    if (!buttonId) return;

    const responseQty = getQuantityFromCartAddResponse(response);
    const lineFromAdd = parseLineItemFromCartAddResponse(response);

    if (lineFromAdd) {
      updateWizzyQuantityWrappersForVariant(buttonId, {
        quantity:
          typeof lineFromAdd.quantity === "number" ? lineFromAdd.quantity : responseQty,
        key: lineFromAdd.key,
      });
    } else if (responseQty != null) {
      updateWizzyQuantityWrappersForVariant(buttonId, { quantity: responseQty });
    }

    const syncQtyFromCart = () => {
      checkCartLimits().then((cart) => {
        if (!cart?.items) return;
        const cartItem = findCartItemByVariantId(cart, buttonId);
        if (cartItem) {
          updateWizzyQuantityWrappersForVariant(buttonId, {
            quantity: cartItem.quantity,
            key: cartItem.key,
          });
        }
      });
    };
    syncQtyFromCart();
    setTimeout(syncQtyFromCart, 600);
  });

  document.addEventListener("theme:cart:change", function () {
    window.requestAnimationFrame(function () {
      syncCartUI();
    });
  });

  // Same idea as quantity-counter.js (non-PDP): when line qty hits 0, skip showing "0" on the tile —
  // snap Wizzy/autocomplete tiles back to ATC (collection tiles use the first .quantity-wrapper match there).
  document.addEventListener(
    "theme:cart:update",
    function (e) {
      const d = e.detail;
      if (!d || d.quantity > 0) return;
      const idAttr = String(d.id);
      window.setTimeout(function () {
        const sel = `.wizzy-result-product .quantity-wrapper[data-variant-id="${idAttr}"], .topproduct-item .quantity-wrapper[data-variant-id="${idAttr}"]`;
        document.querySelectorAll(sel).forEach(function (wrap) {
          wrap.classList.remove("active-qty");
          const cq = wrap.querySelector(".cart-quantity");
          if (cq) cq.textContent = "1";
          const card = wrap.closest(".wizzy-result-product, .topproduct-item");
          if (!card) return;
          const atc = card.querySelector(".add-to-cart-btn");
          if (atc) {
            atc.classList.remove("hide-atc_btn");
            // atc.style.setProperty("display", "block", "important");
          }
          // wrap.style.setProperty("display", "none", "important");
        });
        syncCartUI();
      }, 0);
    },
    false
  );
}

// Reads cart drawer items into a id→quantity map, skipping 0-qty items
function buildCartMapper() {
  let mapper = {};
  document.querySelectorAll(".drawer__inner .drawer__body .cart__item").forEach((item) => {
    let value = parseInt(item.querySelector(".cart__quantity-field").value, 10) || 0;
    let id = item.querySelector(".cart__quantity-field").dataset.productitemId;
    if (value > 0) {
      // Drawer input can briefly exceed 5 before quantity-counter.js reverts; cap for tile display
      mapper[id] = Math.min(value, WIZZY_MAX_UNITS_PER_VARIANT);
    }
  });
  return mapper;
}

// Syncs add-to-cart / quantity-wrapper visibility for all wizzy product cards
function syncCartUI() {
  let mapper = buildCartMapper();
  document.querySelectorAll('.wizzy-result-product, .topproduct-item').forEach((product) => {
    let quantity_wrapper = product.querySelector(".quantity-wrapper");
    // Cart keys match variant id (cart __quantity-field data-productitem-id); li data-id can differ for groups
    let id =
      quantity_wrapper?.getAttribute("data-variant-id") || product.dataset.id;
    let add_to_cart_button = product.querySelector('.add-to-cart-btn');
    if (mapper.hasOwnProperty(id)) {
      if (add_to_cart_button) {
        // add_to_cart_button.style.setProperty("display", "none", "important");
        add_to_cart_button.classList.add("hide-atc_btn");
      }
      if (quantity_wrapper) {
        // quantity_wrapper.style.setProperty("display", "flex", "important");
        quantity_wrapper.classList.add("active-qty");
        let cart_quantity = quantity_wrapper.querySelector(".cart-quantity");
        if (cart_quantity) cart_quantity.textContent = mapper[id];
      }
    } else {
      if (add_to_cart_button) {
        // add_to_cart_button.style.setProperty("display", "block", "important");
        add_to_cart_button.classList.remove("hide-atc_btn");
      }
      if (quantity_wrapper) {
        // quantity_wrapper.style.setProperty("display", "none", "important");
        quantity_wrapper.classList.remove("active-qty");
      }
    }
  });
}

window.syncWizzyCartUI = syncCartUI;

let wizzyEvents = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      if(data.q.toLowerCase() === "combos" ||
        data.q.toLowerCase() === "combo" ||
        data.q.toLowerCase() === "kit" ||
        data.q.toLowerCase() === "kits")
      {
        data.sort = [{"field":"product_wizzy-best-selling_sortOrder:float","order":"desc"}];
      }
      document.querySelector(".search-popdown__close__button").click();

      if(data.sort){
        if(data.sort && data.sort[0].field === "relevance" && data.sort[0].order === "asc"){
          data.sort.push(
            {
              "field": "product_size",
              "order": "desc",
              "isForParent": "false",
              "isForVariation": "true"
            }
          )
        }
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      data.sort = [];
      if(data.sort){
        if(data.sort){
          data.sort.push(
            {
              "field": "product_size",
              "order": "desc"
            }
          )
          data.sort = [
            {
              "field": "relevance",
              "order": "asc"
            },
            {
              "field": "product_size",
              "order": "desc",
              "isForParent": "false",
              "isForVariation": "true"
            }
          ]
        }
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (productsList) {
      productsList.forEach((product) => {
        if (
          typeof product.price !== "undefined" &&
          product.price &&
          product.price.toString().includes(".")
        ) {
          product.price = product.price.toString().split(".")[0];
        }

        if (
          typeof product.sellingPrice !== "undefined" &&
          product.sellingPrice &&
          product.sellingPrice.toString().includes(".")
        ) {
          product.sellingPrice = product.sellingPrice.toString().split(".")[0];
        }

        // Ensure a boolean availability field is available in templates.
        if (typeof product.available === "undefined") {
          if (typeof product.inStock !== "undefined") {
            product.available = product.inStock;
          } else if (typeof product.isAvailable !== "undefined") {
            product.available = product.isAvailable;
          }
          console.log("Available:", product.available);
        }

        // Default value
        product.productWeight = "";

        product.attributes.forEach((attribute) => {
          if (attribute.id === "product_short_description_plp_custom") {
            product.short_description = attribute.values[0].value;
          }
          if (attribute.id === "product_weight_custom") {
            product.productWeight = attribute.values[0].value[0];
          }
          if (attribute.id === "product_stars_product_opinew_metafields") {
            product.opiNewTag = attribute.values[0].value[0];
          }
          if (attribute.id === "product_short_ingredient_custom") {
            product.shortIngrediant = attribute.values[0].value[0];
          }
          if (attribute.id === "product_reviews_average_opinew_metafields") {
            product.opiNewAverageReviews = attribute.values[0].value[0];
            var ratings = parseInt(product.opiNewAverageReviews);
            if(ratings > 0) {
              product.reviewPresent = true;
            }
          }
          if (attribute.id === "product_reviews_count_opinew_metafields") {
            product.totalReviews = attribute.values[0].value[0];
          }
        });
      });

      if(productsList){
        productsList.forEach(product => {
          if(product.swatches){
            product.swatches.forEach(swatch => {
              if(swatch.key === "product_size"){
                if (swatch.values && swatch.values.length > 0){
                  swatch.values.reverse();
                }
              }
            })
          }
        });
      }

      return productsList;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER,
    function (data) {
      const SearchValue = window.wizzyConfig.pageStore.searchInputValue || "";
      if (SearchValue) {
        data.searchQuery = SearchValue;
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      attachWizzyProductInteractions();

      // Strip .00 from prices
      document.querySelectorAll('.wizzy-product-item-price').forEach(priceContainer => {
        priceContainer.querySelectorAll('span').forEach(span => {
          span.textContent = span.textContent.replace('.00', '');
        });
        priceContainer.childNodes.forEach(node => {
          if (node.nodeType === Node.TEXT_NODE) {
            node.textContent = node.textContent.replace('.00', '');
          }
        });
      });

      // Sync cart state for newly rendered cards
      syncCartUI();

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {

      attachWizzyProductInteractions();

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
    function (data) {
      setTimeout(() => {
        const headItem = document.querySelector(
          '.autocomplete-item-head[data-index="0"]'
        );
        if (headItem) {
          headItem.innerHTML = "Top Categories";
        }
      }, 0);
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      return data;
    }
  );
};

let desktop_search_bar = document.querySelector('#wizzy-search-input-desktop');
if (desktop_search_bar) {
  desktop_search_bar.addEventListener("click", function () {
    setTimeout(() => syncCartUI(), 300);
  });
}

if (window.innerWidth > 1165) {
  let header = document.querySelector('header-component');
  header.classList.remove('js__show__mobile');
}
window.onWizzyLoaded.push(wizzyEvents);


////////////////////////////////////////////////////////////////////


const drawer = document.querySelector('.mobile-menu header-drawer');
const searchDetails = document.querySelector('details');

const observerNew = new MutationObserver(() => {
  if (drawer.classList.contains('is-open')) {
    document.body.classList.add('drawer-open');
  } else {
    document.body.classList.remove('drawer-open');
  }
});

observerNew.observe(drawer, { attributes: true, attributeFilter: ['class'] });

const searchBtn = document.querySelector('.navlink.navlink--search');
  // console.log(searchBtn,"search button")
  searchBtn?.addEventListener('click', () => {
  const searchInput = document.querySelector('#wizzy-search-input-desktop');

  if (searchInput) {
    searchInput.click();   // trigger click
    searchInput.focus();   // place cursor in input
  }
});